import React, { useEffect, useState } from 'react'

function BackgroundAnimation() {
  const [shapes, setShapes] = useState([]);

  useEffect(() => {
    const generateShapes = () => {
      const newShapes = [];
      for (let i = 0; i < 20; i++) {
        newShapes.push({
          id: i,
          left: Math.random() * 120 - 10 + '%',
          top: Math.random() * 120 - 10 + '%',
          width: Math.random() * 200 + 100 + 'px',
          height: Math.random() * 200 + 100 + 'px',
          animationDuration: Math.random() * 30 + 20 + 's',
          animationDelay: Math.random() * -50 + 's'
        });
      }
      setShapes(newShapes);
    };

    generateShapes();
  }, []);

  return (
    <div className="background-animation">
      {shapes.map(shape => (
        <div
          key={shape.id}
          style={{
            left: shape.left,
            top: shape.top,
            width: shape.width,
            height: shape.height,
            animationDuration: shape.animationDuration,
            animationDelay: shape.animationDelay
          }}
        />
      ))}
    </div>
  );
}

export default BackgroundAnimation